// バリデーションを行う関数
export const checkRegExp = (str: string, reg: RegExp) => {
  // 正規表現を作成
  const regExp = new RegExp(reg);
  // 正規表現に当てはまっているか確認
  return regExp.test(str);
}
